import React, { createContext, useContext, useState, useEffect } from 'react';
const BadgeContext = createContext();

export function BadgeProvider({ children }) {
  const [badgeCount, setBadgeCount] = useState(0);
  return (
    <BadgeContext.Provider value={{ badgeCount, setBadgeCount }}>
      {children}
    </BadgeContext.Provider>
  );
}

export function useBadge() {
  return useContext(BadgeContext);
}